// removed by extract-text-webpack-plugin
module.exports = {"textarea-span":"TextArea__textarea-span","textareaSpan":"TextArea__textarea-span","text-area":"TextArea__text-area","textArea":"TextArea__text-area","text-area-tooltip-container":"TextArea__text-area-tooltip-container","textAreaTooltipContainer":"TextArea__text-area-tooltip-container","with-tooltip":"TextArea__with-tooltip","withTooltip":"TextArea__with-tooltip","close-icon":"TextArea__close-icon","closeIcon":"TextArea__close-icon","tooltip-button":"TextArea__tooltip-button","tooltipButton":"TextArea__tooltip-button"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextArea/TextArea.css
// module id = 536
// module chunks = 8